import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.10_@babel+core@7.27.1_@playwright+test@1.58.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem"] */ "/vercel/path0/src/app/components/AccordionItem/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/faqs/styles.module.css");
